// extracted by mini-css-extract-plugin
export default {"DeleteDocument":"ExitWithoutSaving_DeleteDocument__OO0d3","deleteDocumentPaper":"ExitWithoutSaving_deleteDocumentPaper__sRwNx"};